import { Checkbox, FormLabel, Group, Input, Select } from '@screentone/core';

import { SectionParameterSchemaEntry } from 'data/generated/graphql';

interface Props {
  schema: SectionParameterSchemaEntry;
  currentValue: string;
  isReadOnly: boolean;
  onChange: (key: string, value: string) => void;
}

const SectionParameterField = ({ schema, currentValue, isReadOnly, onChange }: Props) => {
  const isDeprecated = schema.deprecated === true;
  const fieldLabel = isDeprecated ? `${schema.label} (deprecated)` : schema.label;

  if (schema.type === 'boolean') {
    return (
      <FormLabel key={schema.key} label={fieldLabel} labelPosition="right" fullWidth>
        <Checkbox
          checked={currentValue === 'true'}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onChange(schema.key, e.target.checked ? 'true' : 'false')
          }
          disabled={isDeprecated || isReadOnly}
        />
      </FormLabel>
    );
  }

  if (schema.type === 'enum' && schema.enumValues?.length) {
    return (
      <Group.Item key={schema.key} fullWidth>
        <Group gap="xs" direction="column" fullWidth>
          <FormLabel label={fieldLabel} labelPosition="top" fullWidth />
          <Select
            value={currentValue}
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onChange(schema.key, e.target.value)}
            disabled={isDeprecated || isReadOnly}
          >
            <option value="">— Select —</option>
            {schema.enumValues.map((val) => (
              <option key={val} value={val}>
                {val}
              </option>
            ))}
          </Select>
        </Group>
      </Group.Item>
    );
  }

  return (
    <Group.Item key={schema.key} fullWidth>
      <Group gap="xs" direction="column" fullWidth>
        <FormLabel label={fieldLabel} labelPosition="top" fullWidth />
        <Input
          style={{ width: '100%' }}
          value={currentValue}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(schema.key, e.target.value)}
          placeholder={schema.placeholder ?? schema.label}
          disabled={isDeprecated || isReadOnly}
        />
      </Group>
    </Group.Item>
  );
};

export default SectionParameterField;
